<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";
import { useListItem } from "@/hooks";

const props = defineProps<{ property: string }>();
const { item, style } = useListItem();
const cmpData = computed(() => (item.value ? item.value[props.property] : ""));
</script>
<template>
  <MpText
    class="mp-list-text"
    :model-value="cmpData"
    v-bind="$attrs"
    :extStyle="style"
  />
</template>
